export default __webpack_public_path__ + "static/media/ID_ANDY_Fury.8dc47943.jpg";